import { render, staticRenderFns } from "./TripHistory.vue?vue&type=template&id=6d2c82c1&scoped=true"
import script from "./TripHistory.vue?vue&type=script&lang=js"
export * from "./TripHistory.vue?vue&type=script&lang=js"
import style0 from "./TripHistory.vue?vue&type=style&index=0&id=6d2c82c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2c82c1",
  null
  
)

export default component.exports